$(function () {
  'use strict';

  bsCustomFileInput.init()
});
